// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"-insights-breadcrumbs-wrapper-2MiK1m-","item":"-insights-breadcrumbs-item-1_PbxC-","blockedLoader":"-insights-breadcrumbs-blockedLoader-19mKaZ-"};